import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/warning-orange-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-32a570bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]
const _hoisted_2 = {
  key: 0,
  class: "tw-mt-[10px] tw-flex tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-mr-[10px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-w[17px tw-h-[17px]",
    src: _imports_0
  })
], -1))

import {
  IsPhoneNumber,
  getComponentUiText,
  removeNullProperties,
} from "@/utils/utilities";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import WizardDropdownQuestion from "./wizardDropdownQuestion.vue";
import MoreDetails from "./moreDetails.vue";
import { PropType, Ref, computed, onMounted, reactive, ref, watch } from "vue";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import {
  INPUT_TYPE,
  WIZARD_STATE_PAGE,
  WIZARD_STATE_QUESTION_TYPE_ID,
  idWizardPage as idPage,
  statusPage,
} from "@/utils/constants";

import {
  IWizardQuestion,
  IWizardServicesValue,
  IWizardTypeValue,
} from "@/interfaces/wizard";
import { required, helpers, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import store from "@/store";
import cloneDeep from "lodash/cloneDeep";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'listService',
  props: {
  itemFirst: {
    type: Object as PropType<IWizardServicesValue>,
    required: true,
  },
  currentIndex: {
    type: Number,
    required: true,
  },
  groupIndex: {
    type: Number,
    required: true,
  },
  questionSectionValue: {
    type: Object as PropType<IWizardQuestion[]>,
    required: true,
  },
  currentOrg: {
    type: Number,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: ["update:service", "add:service"],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;



const isCallAPI = ref(false);

const saveChanges = async () => {
  isChangePageClone.value = false;
  await v$.value.$validate();
  if (!initialService.value.showMoreDetails) {
    v$.value.orgServicesName.$reset();
  }
  const isValid = !v$.value.$errors || v$.value.$errors.length === 0;
  if (!isValid) {
    const errors = v$.value.$errors;
    errors.forEach((item) => {
      if (item.$property === "initServiceType") {
        initialService.value.showAccordion = true;
      }
      if (item.$property === "startDate") {
        initialService.value.showAccordion = true;
        isValidForm.value = "1";
      }
      if (
        item.$property === "orgServicesName" ||
        item.$property === "orgServicesProviderEmailCommerical" ||
        item.$property === "orgServicesProviderEmailSupport" ||
        item.$property === "orgServicesProviderPhone"
      ) {
        initialService.value.showAccordion = true;
        initialService.value.question = true;
        isValidForm.value = "1";
        initialService.value.showMoreDetails = true;
      }
    });
  } else {
    processWhenDataValid(true);
  }
  if (isValid) {
    isCallAPI.value = true;
  }
  return { isValid };
};

const processWhenDataValid = (isCloseInput = false) => {
  let finalValue;
  const cacheItem = { ...item.value };
  if (isCloseInput) {
    initialService.value.showAccordion = false;
    initialService.value.showMoreDetails = false;
  }
  let finalOrgService = {} as any;
  if (
    cacheItem.orgServices &&
    cacheItem.orgServices[indexOrgServices.value ?? 0]
  ) {
    finalOrgService = cacheItem.orgServices[indexOrgServices.value ?? 0];
  }
  finalOrgService.name = cacheItem.orgServicesName; //
  finalOrgService.description = cacheItem.orgServicesDescription;
  finalOrgService.serviceComponentTypeId =
    cacheItem.orgServices?.[indexOrgServices.value ?? 0]
      ?.serviceComponentTypeId || null;
  finalOrgService.serviceModelType =
    cacheItem.orgServices?.[indexOrgServices.value ?? 0]?.serviceModelType ||
    null;
  finalOrgService.startDate =
    cacheItem.orgServices?.[indexOrgServices.value ?? 0]?.startDate || null;
  removeNullProperties(finalOrgService);
  finalValue = {
    updated: true,
    description: cacheItem.description || "",
    endDate: cacheItem.endDate || null,
    id: cacheItem.id || null,
    isArchived: cacheItem.isArchived || false,
    name: cacheItem.name || null,
    notes: cacheItem.notes || "",
    orgServices: [finalOrgService],
    serviceTypeId: cacheItem.serviceTypeId,
    startDate: cacheItem.startDate || null,
  } as IWizardServicesValue;
  removeNullProperties(finalValue);
  if (isChangePage) {
    onUpdateValueInStore(finalValue, cacheItem.indexUpdate);
    isChangePage = false;
  } else if (!isCloseInput && item.value.id) {
    onUpdateFormatValueInStore(item);
    onUpdateValueInStore(finalValue, cacheItem.indexUpdate);
  }
};

const onUpdateFormatValueInStore = (value) => {
  store.commit("SetupWizard/SET_FORMAT_VALUES_SERVICE_UPDATE", {
    value,
    currentIndex: props.currentIndex,
    groupIndex: props.groupIndex,
    currentOrg: props.currentOrg,
  });
};

const onUpdateValueInStore = (value, indexUpdate?) => {
  if (indexUpdate !== undefined || item.value.idUpdate) {
    store.commit("SetupWizard/SET_VALUES_SERVICE_UPDATE", {
      value: { ...value, idUpdate: item.value.idUpdate },
      indexUpdate,
      currentOrg: props.currentOrg,
    });
  } else {
    store.commit("SetupWizard/SET_VALUES_SERVICE_UPDATE", {
      value,
      currentOrg: props.currentOrg,
    });
  }
};

const isValidForm: Ref<string> = ref("");

const initialService: Ref<any> = ref({
  showAccordion: false,
  showQuestion: false,
  showMoreDetails: false,
});

const handleSectionsChange = (field?: string) => {
  emits("update:service", cloneDeep(item.value));
  if (statusInPageClone.value && (!item.value.id || field === "name")) {
    isChangePageClone.value = true;
  }
  if (isChangePage) {
    return;
  }
  isChangePage = true;
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    currentOrg: props.currentOrg,
    isSelected: true,
    namePage: WIZARD_STATE_PAGE.SERVICES,
    isSelectedPage: "isSelectedServices",
  });
};



const item = ref({ ...props.itemFirst });

const bodyAPIError = computed(() => {
  if (
    !item.value?.id &&
    props.statusInPage.dataError?.length > 0 &&
    isCallAPI.value
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError?.find((i) => i.id === item.value.id)
  );
});
const statusInPageClone = ref(bodyAPIError);
const isChangePageClone = ref(false);
let isChangePage = false;
const IsStartDateValid = (val) => {
  if (val && item.value.endDate) {
    return new Date(val) < new Date(item.value.endDate);
  }
  return true;
};

const isProviderNameRequired = (val) => {
  if (initialService.value.showMoreDetails) {
    return val ? true : false;
  }
  return true;
};

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  initServiceType: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  startDate: {
    specialChar: helpers.withMessage(
      () => getComponentUiText("app-setting-org-setup-invalid-start-date"),
      IsStartDateValid,
    ),
  },
  orgServicesName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      isProviderNameRequired,
    ),
  },
  orgServicesProviderEmailSupport: {
    specialChar: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-email-1"),
      email,
    ),
  },
  orgServicesProviderEmailCommerical: {
    specialChar: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-email-1"),
      email,
    ),
  },
  orgServicesProviderPhone: {
    phoneNumber: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      IsPhoneNumber,
    ),
  },
};
let v$ = useVuelidate(rules, item as any);
const showMoreDetail: Ref<boolean> = ref(false);
const initServiceComponentType: Ref<any> = ref(null);
const initServiceModelType: Ref<any> = ref(null);
const indexOrgServices: Ref<number> = ref(0);

onMounted(() => initial());

const initial = async () => {
  const componentTypes =
    props.questionSectionValue[0].types[2].typeValues ?? [];
  const modelTypes = props.questionSectionValue[0].types[3].typeValues ?? [];
  // for MVP: find index orgServices which has max id
  const orgServices = cloneDeep(item.value.orgServices || []);
  if (orgServices.length > 0) {
    if (orgServices.length === 1) {
      indexOrgServices.value = 0;
    } else {
      indexOrgServices.value = orgServices
        .map((orgService, index) => ({ ...orgService, index }))
        .filter((orgServiceMap) => !orgServiceMap.isArchived)
        .reduce(
          (max, orgServiceMap) => {
            return orgServiceMap.id > max.id ? orgServiceMap : max;
          },
          { id: -Infinity },
        ).index;
    }
  }
  initServiceComponentType.value =
    componentTypes.find(
      (x) =>
        x.id ===
        item.value.orgServices?.[indexOrgServices.value]
          ?.serviceComponentTypeId,
    ) || {};

  initServiceModelType.value =
    modelTypes.find(
      (x) =>
        x.id ===
        item.value.orgServices?.[indexOrgServices.value]?.serviceModelType,
    ) || {};
};

watch(
  () => props.itemFirst,
  (newValue) => {
    item.value = { ...newValue };
  },
  { immediate: true },
);

watch(
  () => item.value.orgServices?.[indexOrgServices.value]?.serviceModelType,
  () => {
    const modelTypes = props.questionSectionValue[0].types[3].typeValues ?? [];
    initServiceModelType.value =
      modelTypes.find(
        (x) =>
          x.id ===
          item.value.orgServices?.[indexOrgServices.value]?.serviceModelType,
      ) || {};
  },
  { immediate: true },
);

watch(
  () =>
    item.value.orgServices?.[indexOrgServices.value]?.serviceComponentTypeId,
  () => {
    const componentTypes =
      props.questionSectionValue[0].types[2].typeValues ?? [];
    initServiceComponentType.value =
      componentTypes.find(
        (x) =>
          x.id ===
          item.value.orgServices?.[indexOrgServices.value]
            ?.serviceComponentTypeId,
      ) || {};
  },
  { immediate: true },
);

const isPastStatus = () => {
  return item.value.endDate
    ? dayjs(item.value.endDate).isBefore(dayjs(), "day")
    : false;
};

const convertDataDropdown = (typeId) => {
  let data: IWizardTypeValue[] = [];

  if (props.questionSectionValue) {
    props.questionSectionValue[0].types.forEach((item) => {
      if (item.typeId === typeId && !data.length) {
        data = item.typeValues;
      }
    });
  }
  const dataDropdown = data.map((item: IWizardTypeValue) => {
    return {
      name: item.name ?? "",
      value: item.order ?? "",
      id: item.id ?? "",
    };
  });

  return dataDropdown;
};

const isShowDetails = (item) => {
  if (
    item?.componentType?.id ||
    item?.modelType?.id ||
    item?.startDate ||
    item?.endDate ||
    item?.description ||
    item?.notes ||
    item?.modelType?.id
  ) {
    return "1";
  } else {
    return "";
  }
};
__expose({
  saveChanges,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WizardDetailWrapper, {
      title: 
        item.value.parentTitle ? `${item.value.parentTitle}: ${item.value.title}` : item.value.title
      ,
      "is-bg-text": true,
      "is-past": isPastStatus(),
      "show-accordion": initialService.value.showAccordion,
      "name-input": item.value.name,
      "page-active": _unref(idPage).servicesPage,
      validation: _unref(v$).name,
      data: {
        item: item.value,
        index: item.value.indexUpdate,
        currentIndex: __props.currentIndex,
        groupIndex: __props.groupIndex,
      },
      "is-api-error": 
        (item.value?.id || !isChangePageClone.value) &&
        (isChangePageClone.value && item.value?.id
          ? { ...statusInPageClone.value, name: null }
          : statusInPageClone.value)
      ,
      "onUpdate:accordion": _cache[9] || (_cache[9] = ($event: any) => (
        initialService.value.showAccordion = !initialService.value.showAccordion
      )),
      "onUpdate:save:change": processWhenDataValid,
      "onUpdate:input:name": _cache[10] || (_cache[10] = ($event: any) => {
        // eslint-disable-next-line vue/brace-style
        {
          item.value.name = $event;
          handleSectionsChange('name');
        }
      })
    }, {
      title: _withCtx(() => [
        _createElementVNode("input", {
          class: "enter__name",
          placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-domain-placeholder-input-1',
            )
          ,
          style: {"border":"unset","background-color":"unset"},
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass([
          'tw-flex tw-flex-col tw-gap-[20px]',
          showMoreDetail.value ? 'tw-rounded-b-none tw-pb-[25px]' : '',
        ])
        }, [
          _createVNode(WizardDropdownQuestion, {
            index: __props.index,
            title: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-services-question-2',
            )
          ,
            "current-type": item.value.initServiceType,
            placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-sites-prompt-1',
            )
          ,
            "dropdown-data": item.value.serviceTypeOptions,
            "is-api-error": 
            statusInPageClone.value?.serviceTypeId &&
            item.value?.serviceTypeId === statusInPageClone.value?.serviceTypeId
          ,
            required: true,
            validation: _unref(v$).initServiceType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = 
            (value) => {
              item.value.initServiceType = value;
              item.value.serviceTypeId = value.id;
              handleSectionsChange();
            }
          )
          }, null, 8, ["index", "title", "current-type", "placeholder", "dropdown-data", "is-api-error", "validation"]),
          _createVNode(MoreDetails, {
            "classes-more-detail": '!tw-p-0',
            "is-show-questions": false,
            "is-details": isShowDetails(item.value) || isValidForm.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (initialService.value.showQuestion = $event))
          }, null, 8, ["is-details"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([
          'more-detail-container tw-flex tw-flex-col tw-gap-[20px]',
          initialService.value.showQuestion ? 'show' : '',
        ])
        }, [
          (initServiceComponentType.value)
            ? (_openBlock(), _createBlock(WizardDropdownQuestion, {
                key: 0,
                index: __props.index,
                title: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-services-application-type-question-1',
            )
          ,
                placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-sites-prompt-2',
            )
          ,
                "dropdown-data": 
            convertDataDropdown(
              _unref(WIZARD_STATE_QUESTION_TYPE_ID).SERVICE_COMPONENT_TYPE,
            )
          ,
                "is-api-error": 
            statusInPageClone.value?.orgServices?.[0]?.serviceComponentTypeId &&
            item.value?.orgServices?.[0]?.serviceComponentTypeId ===
              statusInPageClone.value?.orgServices?.[0]?.serviceComponentTypeId
          ,
                "class-title": 'tw-text-[14px] !tw-leading-[100%]',
                required: false,
                "current-type": initServiceComponentType.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = 
            (value) => {
              if (!item.value.orgServices || !item.value.orgServices.length) {
                item.value.orgServices = [{}];
              }
              item.value.orgServices[indexOrgServices.value ?? 0].serviceComponentTypeId =
                value.id;

              handleSectionsChange();
            }
          )
              }, null, 8, ["index", "title", "placeholder", "dropdown-data", "is-api-error", "current-type"]))
            : _createCommentVNode("", true),
          _createVNode(WizardInputQuestion, {
            type: _unref(INPUT_TYPE).Date,
            title: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-services-start-date-question-1',
            )
          ,
            required: false,
            validation: _unref(v$).startDate,
            "is-api-error": 
            statusInPageClone.value?.startDate &&
            item.value.startDate === statusInPageClone.value?.startDate
          ,
            placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-start-date-title',
            )
          ,
            "class-title": 'tw-text-[14px] !tw-leading-[100%]',
            "model-value": item.value.startDate,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = 
            (value) => {
              item.value.startDate = _unref(dayjs)(value).format('YYYY-MM-DD');
              _unref(v$).startDate.$validate();
              handleSectionsChange();
            }
          )
          }, null, 8, ["type", "title", "validation", "is-api-error", "placeholder", "model-value"]),
          _createVNode(WizardInputQuestion, {
            type: _unref(INPUT_TYPE).Date,
            title: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-services-end-date-question-1',
            )
          ,
            required: false,
            placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-start-date-title',
            )
          ,
            "is-api-error": 
            statusInPageClone.value?.endDate &&
            item.value.endDate === statusInPageClone.value?.endDate
          ,
            "class-title": 'tw-text-[14px] !tw-leading-[100%]',
            "model-value": item.value.endDate,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = 
            (value) => {
              item.value.endDate = _unref(dayjs)(value).format('YYYY-MM-DD');
              handleSectionsChange();
            }
          )
          }, {
            default: _withCtx(() => [
              (isPastStatus())
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-settings-service-warning-past-1")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["type", "title", "placeholder", "is-api-error", "model-value"]),
          _createVNode(WizardInputQuestion, {
            type: _unref(INPUT_TYPE).TextArea,
            title: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-services-description-question-1',
            )
          ,
            required: false,
            placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-description-title-1',
            )
          ,
            "is-api-error": 
            statusInPageClone.value?.description &&
            item.value.description === statusInPageClone.value?.description
          ,
            "class-title": 'tw-text-[14px] !tw-leading-[100%]',
            "model-value": item.value.description,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = 
            (value) => {
              item.value.description = value;
              handleSectionsChange();
            }
          )
          }, null, 8, ["type", "title", "placeholder", "is-api-error", "model-value"]),
          _createVNode(WizardInputQuestion, {
            type: _unref(INPUT_TYPE).TextArea,
            title: 
            _unref(getComponentUiText)(
              'app-component-assessments-override-question-note-title-1',
            )
          ,
            required: false,
            placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-notes-title-1',
            )
          ,
            "is-api-error": 
            statusInPageClone.value?.notes && item.value.notes === statusInPageClone.value?.notes
          ,
            "class-title": 'tw-text-[14px] !tw-leading-[100%]',
            "model-value": item.value.notes,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = 
            (value) => {
              item.value.notes = value;
              handleSectionsChange();
            }
          )
          }, null, 8, ["type", "title", "placeholder", "is-api-error", "model-value"]),
          (initServiceModelType.value)
            ? (_openBlock(), _createBlock(WizardDropdownQuestion, {
                key: 1,
                index: __props.index,
                title: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-modal-services-modal-type-question-1',
            )
          ,
                placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-service-mode-type-title-1',
            )
          ,
                "is-api-error": 
            statusInPageClone.value?.orgServices?.[0]?.serviceModelType &&
            item.value?.orgServices?.[0]?.serviceModelType ===
              statusInPageClone.value?.orgServices?.[0]?.serviceModelType
          ,
                "dropdown-data": 
            convertDataDropdown(
              _unref(WIZARD_STATE_QUESTION_TYPE_ID).SERVICE_MODEL_TYPE,
            )
          ,
                "class-title": 'tw-text-[14px] !tw-leading-[100%]',
                required: false,
                "current-type": initServiceModelType.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = 
            (value) => {
              if (!item.value.orgServices || !item.value.orgServices.length) {
                item.value.orgServices = [{}];
              }
              item.value.orgServices[indexOrgServices.value ?? 0].serviceModelType =
                value.id;

              handleSectionsChange();
            }
          )
              }, null, 8, ["index", "title", "placeholder", "is-api-error", "dropdown-data", "current-type"]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["title", "is-past", "show-accordion", "name-input", "page-active", "validation", "data", "is-api-error"])
  ]))
}
}

})